import { Button, Icon, Image, Input } from '@smartgift/frontend-toolkit';
import styled from 'styled-components';

import { ToggleMenu } from '@hero/molecules';

const ContactImage = styled(Image)`
  margin-top: 40px;
  max-width: 280px;
  width: 100%;
`;

const MaxContactError = styled.div`
  color: var(--color-error-strong);
  margin-top: 10px;
`;

const AuthorizedDomainWrapper = styled.div`
  background: var(--color-bg-body);
  border: 1px solid var(--color-accent-secondary-weaker);
  border-radius: var(--size-border-radius-md);
  margin: 16px 0;
  padding: 16px;
`;

const DomainManagementWrapper = styled.div`
  width: 100%;
`;

const EmailDomainArea = styled.div`
  display: flex;
  flex-direction: row;
  margin-bottom: 8px;

  ${Input.S.Base} {
    flex: 1;
  }

  ${Button.S.Button} {
    gap: 4px;
  }
`;

const ButtonGroup = styled.div`
  display: flex;
  gap: 16px;
  justify-content: flex-end;
`;

const RecipientQuantityInputArea = styled.div``;

const DomainSubTitle = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;
const ReadOnlyDomainList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 8px;
`;
const MenuTitleWrapper = styled.div``;

const QuantityContainer = styled.div`
  display: flex;
  flex: 0.6;
  flex-direction: column;
  position: relative;
`;

const VerificationWrapper = styled.div`
  background: var(--color-accent-secondary-weakest);
  border-radius: var(--size-border-radius-md);
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-top: 24px;

  ${ToggleMenu.S.ToggleMenuHeader} {
    background-color: var(--color-navy-t8);
  }
`;

const VerificationHead = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-bottom: 16px;
`;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 100%;
`;

const ImageContainer = styled.div`
  align-items: center;
  display: flex;
  flex: 0.4;
  flex-direction: column;
  gap: 8px;
  text-align: center;
`;

const SendWithoutContactCardWrapper = styled.div`
  background-color: var(--color-bg-weaker);
  display: flex;
  flex-direction: row;
  gap: 40px;
  padding: 24px;
  width: 100%;
`;

const UploadEmailArea = styled.div`
  align-items: center;
  background-color: var(--color-gray-50);
  border: 1px solid var(--color-accent-secondary-weaker);
  border-radius: var(--size-border-radius-lg);
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-top: 8px;
  padding: 24px;
`;

const UploadedEmailArea = styled.div`
  align-items: center;
  flex-direction: column;
  margin-top: 8px;
`;

const InfoBadge = styled.div`
  background-color: var(--color-blue-50);
  border: 1px solid var(--color-blue-100);
  border-radius: var(--size-border-radius-md);
  display: flex;
  gap: 8px;
  padding: 8px;
  padding-left: 16px;
`;

const InfoIcon = styled(Icon)`
  background-color: var(--color-blue-600);
  border-radius: var(--radius-full);
  height: 100%;
  width: 100%;
`;

const InfoTypography = styled.div`
  display: inline-block;
  span {
    display: inline;
  }
`;

export {
  AuthorizedDomainWrapper,
  ButtonGroup,
  ContactImage,
  DomainManagementWrapper,
  DomainSubTitle,
  EmailDomainArea,
  ImageContainer,
  InfoBadge,
  InfoIcon,
  InfoTypography,
  MaxContactError,
  MenuTitleWrapper,
  QuantityContainer,
  ReadOnlyDomainList,
  RecipientQuantityInputArea,
  SendWithoutContactCardWrapper,
  UploadEmailArea,
  UploadedEmailArea,
  VerificationHead,
  VerificationWrapper,
  Wrapper
};
